import React from "react";

const UserItem = ({ user, onDelete, onEdit }) => {
  return (
    <tr key={user.id}>
      <td style={{ padding: '10px', border: '1px solid #eee' }}>{user.id}</td>
      <td style={{ padding: '10px', border: '1px solid #eee' }}>{user.name}</td>
      <td style={{ padding: '10px', border: '1px solid #eee' }}>{user.email}</td>
      <td style={{ padding: '10px', border: '1px solid #eee' }}>{user.role}</td>
      <td style={{ padding: '10px', border: '1px solid #eee' }}>
        <button
          onClick={() => onEdit(user)}
          style={{ marginRight: 10, padding: '6px 12px', backgroundColor: '#ffd900', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
        >
          Edit
        </button>
        {user.role !== 'super_admin' && <button
          onClick={() => onDelete(user.id)}
          style={{ padding: '6px 12px', backgroundColor: '#dc3545', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
          Remove
        </button>}
      </td>
    </tr>
  );
};

export default UserItem;